import { ISearchCompany } from '@/models'

export const getSearchPreviewForecast = async (api: string, searchText: string): Promise<ISearchCompany[]> => {
    const res = await fetch(`${api}forecasts/search-preview?searchText=${searchText}`)
    const forecasts = await res.json()
    return forecasts

    // const resultItems = [
    //     { capCategory: '4:Large', companyId: 14058, name: 'Agilent Technologies Inc', ticker: 'A' },
    //     { capCategory: '4:Large', companyId: 14059, name: 'Alcoa Corp', ticker: 'AA' },
    //     { capCategory: '4:Large', companyId: 14079, name: 'American Airlines Group Inc', ticker: 'AAL' },
    //     { capCategory: '1:Micro', companyId: 14085, name: 'Applied Optoelectronics Inc', ticker: 'AAOI' },
    //     { capCategory: '4:Large', companyId: 14087, name: 'Advance Auto Parts Inc', ticker: 'AAP' },
    //     { capCategory: '6:Giga', companyId: 14090, name: 'Apple Inc', ticker: 'AAPL' },
    //     { capCategory: '3:Mid', companyId: 14100, name: 'Atlas Air Worldwide Holdings Inc', ticker: 'AAWW' },
    //     { capCategory: '5:Mega', companyId: 14112, name: 'AbbVie Inc', ticker: 'ABBV' },
    //     { capCategory: '4:Large', companyId: 14113, name: 'Amerisourcebergen Corp', ticker: 'ABC' },
    //     { capCategory: '3:Mid', companyId: 14114, name: 'Ameris Bancorp', ticker: 'ABCB' },
    // ]

    // return resultItems
}
